import React from "react";
import { Container, Image } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import detailSvg from "../images/detail.svg";
import uniqueSvg from "../images/uniqueness.svg";
import meSvg from "../images/me.svg";
import contSvg from "../images/controller.svg";
import { motion } from "framer-motion";
import Neontag from "./subcomponents/Neontag";

export const Passion = () => {
	return (
		<Container id="widthRes" className="pb-5 pt-5">
			<motion.h1
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				exit={{ opacity: 0 }}
				transition={{ duration: 0.5 }}
				className=" text-light text-center m-4 p-3 mt-4 mb-5 border-bottom border-top  rounded"
			>
				About Me
			</motion.h1>
			<Row className="d-flex flex-column flex-md-row p-5 justify-content-center align-items-center">
				<Col>
					<motion.div
						initial={{ opacity: 0, scale: 0 }}
						whileInView={{ opacity: 1, scale: 1 }}
						transition={{ duration: 1, type: "spring" }}
						layout
					>
						<h2 className="text-blue">Pursuit of Education</h2>
						<p className="text-white">
							I am currently a senior at York University, pursuing
							a Bachelor's in Computer Science with a Specialized
							Honors degree focusing on Data and Security. As part
							of my academic career I have also been honored to be
							recognized as a Lassonde Scholar for my exceptional
							academic performance, extracurricular activities,
							and community involvement in the Department of
							Electrical Engineering and Computer Science at York
							University.
						</p>
					</motion.div>
				</Col>
			</Row>
			<Row className="d-flex flex-column flex-md-row p-5 justify-content-center align-items-center">
				<Col>
					<motion.div
						className="d-flex w-100 justify-content-center align-items-center"
						initial={{ opacity: 0, scale: 0 }}
						whileInView={{ opacity: 1, scale: 1 }}
						transition={{
							duration: 0.5,
							type: "spring",
							delay: 0.5,
						}}
						layout
					>
						<Image
							className="paraImg w-75 mt-4"
							fluid
							src={meSvg}
						/>
					</motion.div>
				</Col>
				<Col
					as={motion.div}
					initial={{ opacity: 0 }}
					whileInView={{ opacity: 1 }}
					transition={{ duration: 0.1 }}
				>
					<Neontag
						heading={"Data expert"}
						subheading={"skilled at efficient data solutions"}
						delay={0.5}
						flicker={true}
					/>
					<Neontag
						heading={"Resolute"}
						subheading={
							"always aiming for optimal and precise solutions"
						}
						delay={1}
						flicker={false}
					/>
					<Neontag
						heading={"Innovative"}
						subheading={
							"creative, intuitive, outside-the-box designs"
						}
						delay={1.5}
						flicker={false}
					/>
					<Neontag
						heading={"Visionary"}
						subheading={"developing for scalability and longevity"}
						delay={2}
						flicker={false}
					/>
					<Neontag
						heading={"Explorer"}
						subheading={
							"eager to learn, and grow my knowledge base"
						}
						delay={2.5}
						flicker={true}
					/>
					<Neontag
						heading={"Nimble"}
						subheading={
							"never settling for anything less than excellent"
						}
						delay={2.5}
						flicker={false}
					/>
				</Col>
			</Row>
			<Row className="d-flex flex-column flex-md-row p-5 justify-content-center align-items-center">
				<Col>
					<motion.div
						initial={{ opacity: 0, scale: 0 }}
						whileInView={{ opacity: 1, scale: 1 }}
						transition={{ duration: 1, type: "spring" }}
						layout
					>
						<h3 className="text-blue text-center">
							Attention to Detail
						</h3>
						<hr className="text-light" />
						<p className="text-white">
							As a detail-oriented person, I approach everything I
							do with precision and care, taking the time to
							ensure that everything is done to the best of my
							abilities. Accompanying that with my strong
							time-management skills, I make a great asset to my
							team.
						</p>
					</motion.div>
				</Col>
				<Col>
					<motion.div
						initial={{ opacity: 0, scale: 0 }}
						whileInView={{ opacity: 1, scale: 1 }}
						transition={{ duration: 1, type: "spring" }}
						layout
					>
						<Image className="paraImg" fluid src={detailSvg} />
					</motion.div>
				</Col>
			</Row>
			<Row className="d-flex flex-column flex-md-row p-5 justify-content-center align-items-center">
				<Col className="d-none d-md-block">
					<motion.div
						initial={{ opacity: 0, scale: 0 }}
						whileInView={{ opacity: 1, scale: 1 }}
						transition={{ duration: 1, type: "spring" }}
						layout
					>
						<Image className="paraImg" fluid src={contSvg} />
					</motion.div>
				</Col>
				<Col>
					<motion.div
						initial={{ opacity: 0, scale: 0 }}
						whileInView={{ opacity: 1, scale: 1 }}
						transition={{ duration: 1, type: "spring" }}
						layout
					>
						<h3 className="text-blue text-center">
							Hobby turned Pro
						</h3>
						<hr className="text-light" />
						<p className="text-white">
							Gaming has been an integral part of my life, and I
							got the opportunity to turn my hobby into a career.
							More specifically, I played CDL, which is Call of
							Duty's Pro League, in multiple cross platform
							tournaments and placed with 2 Podiums with regional
							recognition. My dedication and hardwork have allowed
							me to excel in this competitive field, and has made
							me known for my team work capabilites along side
							keeping a strong positive mindset.
						</p>
					</motion.div>
				</Col>
				<Col className="d-md-none">
					<motion.div
						initial={{ opacity: 0, scale: 0 }}
						whileInView={{ opacity: 1, scale: 1 }}
						transition={{ duration: 1, type: "spring" }}
						layout
					>
						<Image className="paraImg" fluid src={contSvg} />
					</motion.div>
				</Col>
			</Row>
			<Row className="d-flex flex-column flex-md-row p-5 justify-content-center align-items-center">
				<Col>
					<motion.div
						initial={{ opacity: 0, scale: 0 }}
						whileInView={{ opacity: 1, scale: 1 }}
						transition={{ duration: 1, type: "spring" }}
						layout
					>
						<h3 className="pt-5 pt-md-0 text-blue text-center">
							Uniqueness
						</h3>
						<hr className="text-light" />
						<p className="text-white">
							My diverse interests and skills have shaped my
							unique perspective and contributed to my success and
							accomplishments thus far. As someone who is
							passionate about learning, I am committed to
							continuing my personal and professional growth in
							the future, and look forward to achieving even
							greater success.
						</p>
					</motion.div>
				</Col>
				<Col>
					<motion.div
						initial={{ opacity: 0, scale: 0 }}
						whileInView={{ opacity: 1, scale: 1 }}
						transition={{ duration: 1, type: "spring" }}
						layout
					>
						<Image className="paraImg" fluid src={uniqueSvg} />
					</motion.div>
				</Col>
			</Row>
		</Container>
	);
};
